export const APP_PROTOCOL = 'shootsta-cast://login';